<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-logo">
        <div class="logo-icon">C</div>
        <h1>COG主播平台后台管理系统</h1>
        <p>主播可信资产综合服务平台</p>
      </div>

      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="0px"
        class="login-form">
        <el-form-item prop="username">
          <label class="field-label">管理员账号</label>
          <el-input v-model="ruleForm.username" placeholder="请输入管理员账号"></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <label class="field-label">管理员密码</label>
          <el-input v-model="ruleForm.password" type="password" placeholder="请输入管理员密码"></el-input>
        </el-form-item>

        <el-form-item prop="captcha_code">
          <label class="field-label">图形验证码</label>
          <div class="captcha-row">
            <el-input
              v-model="ruleForm.captcha_code"
              placeholder="请输入验证码"
              @keyup.enter.native="submitForm('ruleForm')"></el-input>
            <img :src="codeimg" alt="验证码" class="codeimg" @click="getcode">
          </div>
        </el-form-item>

        <div class="login-options">
          <el-checkbox v-model="rememberpwd">记住密码</el-checkbox>
          <button type="button" class="link-button" @click="getcode">刷新验证码</button>
        </div>

        <el-form-item>
          <button type="button" class="btn-login" :disabled="logining" @click="submitForm('ruleForm')">
            {{ logining ? '登录中...' : '登 录' }}
          </button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { login, captcha, adminu } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'

export default {
  name: 'login',
  data() {
    return {
      logining: false,
      rememberpwd: false,
      ruleForm: {
        username: '',
        password: '',
        captcha_code: '',
        captcha_key: ''
      },
      codeimg: '',
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha_code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getcode()
    this.getuserpwd()
  },
  methods: {
    getuserpwd() {
      if (getCookie('user') !== '' && getCookie('pwd') !== '') {
        this.ruleForm.username = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          this.getcode()
          this.logining = false
          return false
        }

        this.logining = true
        login(this.ruleForm).then(res => {
          const token = this.getTokenFromResponse(res)

          if (token) {
            if (this.rememberpwd) {
              setCookie('user', this.ruleForm.username, 7)
              setCookie('pwd', this.ruleForm.password, 7)
            } else {
              delCookie('user')
              delCookie('pwd')
            }

            localStorage.setItem('logintoken', this.normalizeToken(token))
            this.syncCurrentAdmin(res)
            return
          }

          this.$message.error(this.getErrorMessage(res, '登录成功，但未获取到令牌'))
          this.getcode()
          this.logining = false
        })
      })
    },
    getcode() {
      captcha().then(res => {
        const captchaData = res && res.data ? res.data : res
        this.ruleForm.captcha_key = captchaData.key || captchaData.captcha_key || ''
        this.ruleForm.captcha_code = ''
        this.codeimg = captchaData.img || captchaData.captcha_image || ''
      })
    },
    getTokenFromResponse(res) {
      const data = res && res.data ? res.data : null
      const candidates = [
        res && res.token,
        res && res.access_token,
        res && res.userToken,
        data && data.token,
        data && data.access_token,
        data && data.userToken,
        data && data.accessToken
      ]

      for (let i = 0; i < candidates.length; i++) {
        if (typeof candidates[i] === 'string' && candidates[i]) {
          return candidates[i]
        }
      }

      return ''
    },
    normalizeToken(token) {
      return String(token || '').replace(/^Bearer\s+/i, '')
    },
    getErrorMessage(res, defaultMessage) {
      if (!res) {
        return defaultMessage
      }

      if (res.message) {
        return res.message
      }

      if (res.errors) {
        const keys = Object.keys(res.errors)
        if (keys.length) {
          const firstError = res.errors[keys[0]]
          if (firstError && firstError.length) {
            return firstError[0]
          }
        }
      }

      if (res.detail) {
        return res.detail
      }

      return defaultMessage
    },
    syncCurrentAdmin(res) {
      const redirect = this.$route.query.redirect || '/dashboard'
      const finishLogin = userInfo => {
        localStorage.setItem('userInfo', JSON.stringify(userInfo || {}))
        this.$store.commit('login', userInfo || {})
        this.$message({
          message: '登录成功',
          type: 'success'
        })
        this.logining = false
        this.$router.push({ path: redirect })
      }

      adminu()
        .then(adminRes => {
          const adminData = adminRes && adminRes.data ? adminRes.data : adminRes
          if (adminData && typeof adminData === 'object' && !adminData.message && !adminData.detail && !adminData.errors) {
            finishLogin(adminData)
            return
          }

          finishLogin({ username: this.ruleForm.username })
        })
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  padding: 24px;
  background: linear-gradient(135deg, #eef2ff, #f0f9ff, #f5f3ff, #ecfeff);
  position: relative;
}

.login-page::before,
.login-page::after {
  content: '';
  position: fixed;
  border-radius: 50%;
  pointer-events: none;
}

.login-page::before {
  top: -180px;
  right: -120px;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(79, 70, 229, 0.08) 0%, transparent 70%);
}

.login-page::after {
  bottom: -200px;
  left: -150px;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(6, 182, 212, 0.06) 0%, transparent 70%);
}

.login-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 440px;
  padding: 48px 40px 36px;
  background: #fff;
  border: 1px solid rgba(226, 232, 240, 0.6);
  border-radius: var(--cog-radius-lg);
  box-shadow: var(--cog-shadow-lg);
  overflow: hidden;
}

.login-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
}

.login-logo {
  text-align: center;
  margin-bottom: 28px;
}

.logo-icon {
  display: inline-flex;
  width: 54px;
  height: 54px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  margin-bottom: 12px;
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
  color: #fff;
  font-size: 24px;
  font-weight: 800;
}

.login-logo h1 {
  margin: 0;
  font-size: 22px;
  color: var(--cog-text);
}

.login-logo p {
  margin: 8px 0 0;
  font-size: 13px;
  color: var(--cog-text-muted);
}

.field-label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--cog-text);
}

.captcha-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 118px;
  gap: 10px;
}

.codeimg {
  width: 118px;
  height: 40px;
  display: block;
  box-sizing: border-box;
  border-radius: var(--cog-radius-sm);
  border: 1px solid var(--cog-border);
  cursor: pointer;
  object-fit: contain;
  object-position: center;
  background: #fff;
}

.login-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.link-button {
  border: none;
  padding: 0;
  background: transparent;
  color: var(--cog-primary);
  font-size: 13px;
  cursor: pointer;
}

.btn-login {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: var(--cog-radius-sm);
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: var(--cog-transition);
}

.btn-login:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(79, 70, 229, 0.25);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 480px) {
  .login-page {
    padding: 16px;
  }

  .login-card {
    padding: 36px 22px 24px;
  }

  .captcha-row {
    grid-template-columns: 1fr;
  }

  .codeimg {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue